export default __webpack_public_path__ + "static/media/login_modal_img.32d8a2d2.png";